import times from 'lodash/times';
import flatten from 'lodash/flatten';
import isInteger from 'lodash/isInteger';

/**
 * Parse a grid area template into a matrix of strings
 */

function parseTemplate(template) {
  var sourceTemplateRowsMatch = template.match(/\"[^\"]+\"/g);

  if (!sourceTemplateRowsMatch) {
    throw new Error("Can not parse template " + template);
  }

  return sourceTemplateRowsMatch.map(function (row) {
    return row.slice(1, -1);
  }) // Remove the leading and trailing double quotes
  .map(function (row) {
    return row.trim();
  }) // Remove excess leading and trailing whitespace
  .map(function (row) {
    return row.split(/\s+/);
  }); // Tokenize by whitespace
}
/**
 * Trim excess whitespace from a grid area template
 */

function minifyTemplate(template) {
  var parsed = parseTemplate(template);
  return '"' + parsed.map(function (row) {
    return row.join(' ');
  }).join('" "') + '"';
}
/**
 * Calculate the number of columns in a given grid area template
 */

function columnCountFromTemplate(template) {
  var parsed = parseTemplate(template);
  return Math.max.apply(Math, parsed.map(function (row) {
    return row.length;
  }));
}
/**
 * Given a grid areas template, `sourceTemplate`, extrapolate it to fill `targetColumnCount`:
 *
 * For example, the template:
 *
 *     "a a a b c d"
 *     "a a a e f g"
 *
 * Extrapolated to `12` columns:
 *
 *     "a a a a a a b b c c d d"
 *     "a a a a a a e e f f g g"
 *
 * Note: spacing is not preserved.
 */

function extrapolateTemplate(templateString, targetColumnCount) {
  var template = parseTemplate(templateString);
  var scaleFactor = targetColumnCount / template[0].length;

  if (!isInteger(scaleFactor)) {
    throw new Error("Can not evenly extrapolate template " + templateString + " to " + targetColumnCount + " columns.");
  }

  return template.map(function (row) {
    var extrapolatedRow = row.reduce(function (multiplied, areaName) {
      return multiplied.concat(times(scaleFactor, function () {
        return areaName;
      }));
    }, []).join(' ');
    return "\"" + extrapolatedRow + "\"";
  }).join(' ');
}
/**
 * Given a griad areas template, determine if a given area name is present in that template
 */

function doesTemplateIncludeArea(templateString, areaName) {
  return flatten(parseTemplate(templateString)).includes(areaName);
}

export { columnCountFromTemplate, doesTemplateIncludeArea, extrapolateTemplate, minifyTemplate, parseTemplate };
//# sourceMappingURL=templates.js.map
